import { IUser } from "@faire/web-api/indigofair/data/IUser";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";

export const getUser = (): IUser | undefined => getGlobalProperty("user");
